import React from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useRhmAuth } from "./RhmAuthContext";

export default function Guard({ perm, children }) {
    const { can } = useRhmAuth();
    if (can(perm)) return children;
    return (
        <div className="max-w-lg" data-testid="rhm-access-denied">
            <div className="w-12 h-12 border border-red-500/40 text-red-400 flex items-center justify-center mb-5">
                <ShieldOff className="w-5 h-5" />
            </div>
            <h1 className="font-display text-3xl tracking-tight">Access denied</h1>
            <p className="text-sm text-zinc-400 mt-3">
                Your role does not include the <span className="mono text-gold">{perm}</span> permission.
                Ask a Super Admin to grant it from Roles &amp; Permissions.
            </p>
            <Link to="/rhm" className="mono text-[10px] tracking-[0.18em] text-gold mt-6 inline-block">
                BACK TO DASHBOARD
            </Link>
        </div>
    );
}
